import type { Node } from '@xyflow/react';

type RFNode = Node;

/**
 * If pendingRef.current names a node that is now in the list, mark it
 * selected and clear the ref. Returns the same array reference when no
 * action is taken so callers can skip a re-render.
 */
export function applyPendingSelect(
  nodes: RFNode[],
  pendingRef: { current: string | null },
): RFNode[] {
  const id = pendingRef.current;
  if (!id) return nodes;
  const idx = nodes.findIndex(n => n.id === id);
  if (idx === -1) return nodes;
  pendingRef.current = null;
  return nodes.map((n, i) => i === idx ? { ...n, selected: true } : { ...n, selected: false });
}
